import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { addCommas } from '@persian-tools/persian-tools';
import { AuthService } from 'src/app/core';
import { DiscountService } from 'src/app/feature/services';
import { Discount, DiscountType } from 'src/app/shared';

@Component({
  selector: 'shared-discount',
  templateUrl: './discount.component.html',
  styleUrls: ['./discount.component.scss'],
})
export class DiscountComponent implements OnInit {
  @Input('discountItem') discountType!: DiscountType;
  @Input('discount') discount!: Discount;
  @Input('preview') preview!: boolean;

  @Output('buyEvent') buyEvent!: EventEmitter<{
    id: number;
    authorizeAction: boolean;
  }>;

  ngOnInit(): void {}
  constructor(
    private discountService: DiscountService,
    private authService: AuthService
  ) {
    this.buyEvent = new EventEmitter();
  }

  withCommas(input: number | string) {
    return addCommas(input.toString());
  }

  displayPriceOneSingle() {
    return this.withCommas(
      Math.round(this.discountType.price / this.discountType.pages)
    );
  }

  buyThis() {
    this.authService.isLoggedIn().then((result) => {
      if (!result) {
        this.authService
          .openAuthBox('login')
          ?.afterClosed()
          .subscribe(() => {
            this.openDiscountOrderBox();
          });
        return; // end
      }
      this.openDiscountOrderBox();
      return;
    });
  }

  // Open discount order.
  private openDiscountOrderBox(): void {
    this.discountService.buy(this.discountType.id);
  }

  sayDays() {
    return this.discountType.exp / (60 * 60 * 24);
  }
  sayRemainingDays() {
    if (this.discount?.remainTime > 0) {
      return Math.floor(this.discount?.remainTime / (60 * 60 * 24));
    }
    return 0;
  }
}
